// @file Vue composable for all panel related logic in Slideshow

import { useSlideshowStore } from '@@/pinia/slideshow'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

export const useSlideshowPanels = (): {
  isSharePanelOpen: Ref<boolean>
  isShareViaAnotherAppPanelOpen: Ref<boolean>
  isEmbedPanelOpen: Ref<boolean>
  isLanguagePanelOpen: Ref<boolean>
  isAccessibilitySettingsModalOpen: Ref<boolean>
} => {
  const {
    isSharePanelOpen,
    isShareViaAnotherAppPanelOpen,
    isEmbedPanelOpen,
    isLanguagePanelOpen,
    isAccessibilitySettingsModalOpen,
  } = storeToRefs(useSlideshowStore())

  return {
    isSharePanelOpen,
    isShareViaAnotherAppPanelOpen,
    isEmbedPanelOpen,
    isLanguagePanelOpen,
    isAccessibilitySettingsModalOpen,
  }
}
